import React from 'react';
import { IonItem, IonLabel, IonText } from '@ionic/react';
import { Holiday } from '../../../models';
import { dateToFormat, tsToServerDate } from '../../../utils/ages';
import { isMultiDay } from '../../../utils/holidays';

interface Props {
    holiday: Holiday;
}

const UpcomingHolidayRow: React.FC<Props> = ({ holiday }) => {
    const start = tsToServerDate(holiday.startDateTs);
    const end = tsToServerDate(holiday.endDateTs);

    return (
        <IonItem className="upcoming-holiday-row">
            <div slot="start" className="upcoming-holiday-date">
                <IonText color="medium"><p className="dow">{dateToFormat(start, 'ddd')}</p></IonText>
                <IonText><p className="date">{dateToFormat(start, 'dd mmm')}</p></IonText>
            </div>
            <IonLabel>
                <h3>{holiday.name}</h3>
                {isMultiDay(holiday) && <p>{`Until ${dateToFormat(end, 'ddd dd mmm')}`}</p>}
            </IonLabel>
        </IonItem>
    );
};

export default UpcomingHolidayRow;
